import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useRef } from 'react';

import { observeIntersectionOnce, useIntersection } from '@flipster/react/misc/browser/intersection';
import { css } from '@flipster/styled-system/css';
import segment from '@flipster/utils/segment';
import { CompetitionsEvent } from '@flipster/utils/segment/events/competitions';

import { SegmentPage } from '../../../misc/segment/segment-page';
import { competitionRankingBunja } from '../../bunja';
import { RankingList } from './list';
import { WinnerAndLoser } from './winner-and-loser';

export const Ranking = () => {
  const { payloadAtom, rankingsAtom } = useBunja(competitionRankingBunja);
  const rankings = useAtomValue(rankingsAtom);
  const payload = useAtomValue(payloadAtom);

  const ref = useRef<HTMLDivElement>(null);
  useIntersection(
    ref,
    observeIntersectionOnce(() => {
      segment.track(CompetitionsEvent.CompetitionLandingViewPageScroll, {
        section_title: 'Ranking',
      });
    }),
  );

  if (rankings?.length < 4) return null;

  return (
    <>
      <SegmentPage name={CompetitionsEvent.CompetitionRankingPageView} context={payload} />
      <section
        ref={ref}
        className={css({
          tabletDown: {
            m: '30px 16px',
          },
          tablet: {
            maxW: 'desktopMaxWidth',
            m: '60px auto',
          },
          tabletOnly: {
            p: '0 36px',
          },
        })}
        data-test-id='tc_ranking_award'
      >
        <WinnerAndLoser />
        <RankingList />
      </section>
    </>
  );
};
